import React from 'react'
import { BellOff } from 'lucide-react'

class NotificationStatus extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      hidden: false
    }
  }

  onAskPermission = () => {
    Notification.requestPermission((status) => {
      // This lets us use Notification.permission with Chrome/Safari
      // if (Notification.permission !== status) {
      //   Notification.permission = status
      // }

      if (status == 'granted') {
        this.setState({hidden: true})
      }
    })
  }

  render() {
    if (this.state.hidden) {
      return null
    }

    if (Notification.permission !== 'granted') {
      return (
        <BellOff className="size-4 cursor-pointer text-muted-foreground" title='You have not provided permission to receive browser notifications.' onClick={this.onAskPermission} />
      )
    }

    return null
  }
}

export default NotificationStatus
